module.exports = __webpack_public_path__ + "media/images/features/5/icon-case1-c998c03f26c957a8da634b082cdc19c3.png";